/**
 * Helper class containing parse functions.
 *
 * @class
 *
 **/
class AnalyticsParser {

    static parseLaunch(launcherConfig) {
        return {
            gaTrackingIds: launcherConfig.gaTrackingIds
        };
    }

    static parse(cfg) {
        cfg.analytics = {
            gaTrackingIds: [],
            sendUsageData: true,
            isFake: false,
            ...cfg.analytics
        };

        return cfg.analytics;
    }


}


module.exports = AnalyticsParser;
